import React from "react";
import '../custom frames/frame-style.scss'
import FrameWithImage from "./FrameWithImage";

const FrameContent = () => {
    return (
        <div class = 'top-content-all'>
            <div class='title-top-content'>Nuestras actividades mas recientes</div>
             <div class="frame-top-content">
                <FrameWithImage
                    style = {"activity-1"}
                    title = {"Recolección de juguetes para Maracaibo, Venezuela"}
                    content = {"La Sociedad San Vicente de Paul, Conferencia Guadalupe y Funda Angel estaran recolectando..."}
                ></FrameWithImage>
                <FrameWithImage
                    style = {"activity-2"}
                    title = {"Brunch de Navidad 2020"}
                    content = {"La Sociedad San Vicente de Paul, Conferencia Guadalupe y Funda Angel estaran recolectando..."}
                ></FrameWithImage>
                <FrameWithImage
                    style = {"activity-3"}
                    title = {"Desayuno de Accion de Gracias"}
                    content = {"La Sociedad San Vicente de Paul, Conferencia Guadalupe y Funda Angel estaran recolectando..."}
                ></FrameWithImage> 
            </div> 
        </div>
    );
}


export default FrameContent;